import { render, staticRenderFns } from "./ListType.vue?vue&type=template&id=60844046&"
import script from "./ListType.vue?vue&type=script&lang=js&"
export * from "./ListType.vue?vue&type=script&lang=js&"
import style0 from "./ListType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports